import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
`;

const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => !['primary'].includes(prop),
})`
  background: ${props => props.primary ? props.theme.colors.gradient : 'transparent'};
  border: 1px solid ${props => props.primary ? 'transparent' : props.theme.colors.border};
  color: ${props => props.primary ? 'white' : props.theme.colors.text.primary};
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.md};
  cursor: pointer;
  font-size: ${props => props.theme.typography.small.fontSize};
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.primary ? props.theme.colors.gradientHover : props.theme.colors.surfaceVariant};
    border-color: ${props => props.primary ? 'transparent' : props.theme.colors.primary};
    color: ${props => props.primary ? 'white' : props.theme.colors.primary};
  }
`;

const AuthButtons = ({ onLogin }) => {
  const navigate = useNavigate();

  return (
    <ButtonGroup>
      <Button onClick={() => navigate('/login')}>
        Login
      </Button>
      <Button primary onClick={() => navigate('/register')}>
        Sign Up
      </Button>
    </ButtonGroup>
  );
};

export default AuthButtons; 